export const enum TabKey {
  Suggested = 'suggested',
  Following = 'following',
  Scheduled = 'scheduled',
}

export const HOME_TABS = [
  {
    id: TabKey.Suggested,
    label: 'Top Picks',
  },
  {
    id: TabKey.Following,
    label: 'For You',
  },
  {
    id: TabKey.Scheduled,
    label: 'Scheduled',
  },
];
